import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import baseUrl from './modules/baseUrl';
import wxAuth from './modules/wxAuth';
import userInfo from './modules/userInfo';
import provincialGrade from './modules/provincialGrade';
// import habitUserInfo from './modules/habitUserInfo';
// import habitJournal from './modules/habitJournal';
// import habitCard from './modules/habitCard';
// import audioStatus from './modules/audioStatus';
// import lRecordModel from './modules/lRecordModel';
// import hRecordModel from './modules/hRecordModel';
// import lAnswerModel from './modules/lAnswerModel';
// import mAnswerModel from './modules/mAnswerModel';
// import mRecordModel from './modules/mRecordModel';
// import habitLower from './modules/habitLower';
// import habitUserInfoPrev from './modules/habitUserInfoPrev';
// import habitCardPrev from './modules/habitCardPrev';
// // 七大能力
// import sevenAbilityPlayer from './modules/sevenAbilityPlayer';
// import sevenAbilityGames from './modules/sevenAbilityGames';
// import sevenAbilityIntroduce from './modules/sevenAbilityIntroduce';
// // 新年换装2018
// import happyNewYear2018 from './modules/happyNewYear2018'
const store = new Vuex.Store({
    modules: {
        baseUrl,
        wxAuth,
        userInfo,
        provincialGrade,
        // // 21天
        // habitUserInfo,
        // habitJournal,
        // habitCard,
        // audioStatus, // audio 播放状态总线
        // lRecordModel, // low-l1-3-model
        // lAnswerModel, //low-l1-3-answer-model
        // mAnswerModel, // mid L4-6
        // mRecordModel, // mid L4-6
        // habitLower, //low-l1-3
        // hRecordModel, //higher-l7-9-model
        // //21天预览
        // habitUserInfoPrev,
        // habitCardPrev,
        // // 七大能力
        // sevenAbilityPlayer,
        // sevenAbilityGames,
        // sevenAbilityIntroduce,
        // // 新年换装2018
        // happyNewYear2018
    }
});
export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js